import { AxiosResponse } from 'axios'
import axios from '../config/axios'
import {
  EnquadramentoIpiOption,
  ListNcmNaturezasParams,
  ListNcmProfilesParams,
  NcmNaturezaDto,
  NcmCatalogoPosicao,
  NcmProfileDto,
  NcmProfilesListResponse,
  NcmVinculoCandidato,
  NcmVinculoPrevia,
  NcmVinculoResumo,
  NcmVinculosResponse,
  NcmVinculoTipo,
  NcmVinculoTrocaPayload,
  NcmVinculoTrocaResultado,
  UpdateNcmProfilePayload,
  UpsertNcmProfilePayload,
} from '../pages/ClientPanel/TaxModule/TaxScenario/NcmRules/types'
import {
  CandidataEmissor,
  CreateEmissorPayload,
  EmissorPainel,
  NumeracaoPayload,
  PainelResponse,
  UpdateEmissorPayload,
  UsoEmissor,
} from '../pages/ClientPanel/TaxModule/Settings/types'

// Contrato substitutivo de POST /fiscal/tax-config/cotacao (D4) — impostos já resolvidos
// pelo backend, sem taxConfig/taxScenario crus. Decimal do Prisma chega como string.
export interface ImpostoResolvido {
  cst: string | null
  aliquota: string | null
  enquadramento?: string | null
  classificacaoTributaria?: string | null
  origem: string
}

export interface CotacaoTributoItem {
  orderItemId: number
  resolvido: boolean
  motivo?: string
  taxScenarioId?: number
  impostos?: {
    icms: ImpostoResolvido
    ipi: ImpostoResolvido
    pis: ImpostoResolvido
    cofins: ImpostoResolvido
    ibs: ImpostoResolvido
    cbs: ImpostoResolvido
  }
  valores?: { icms?: string | null; ipi?: string | null; ibs?: string | null; cbs?: string | null }
  avisos?: string[]
}

class ApiService {
  private static baseUrl = process.env.REACT_APP_GATEWAY_BASE_URL

  static async get(url: string, params?: any, config?: any) {
    const isAbsoluteUrl = url.startsWith('http')
    const finalParams = (params && typeof params === 'object' && params.params) ? { ...params.params, ...params, params: undefined } : params

    if (isAbsoluteUrl) {
      const baseUrl = this.baseUrl || ''
      const finalUrl = baseUrl && url.startsWith(baseUrl) ? url.substring(baseUrl.length) : url
      const response = await axios.get(finalUrl, { params: finalParams, ...config })
      return response
    }

    const response = await axios.get(url, { params: finalParams, ...config })
    return response
  }

  static async post(url: string, data?: any, config?: any) {
    console.log('🚀 [APISERVICE] POST chamado:', {
      url,
      hasData: !!data,
      dataType: data?.constructor?.name || typeof data,
      isFormData: data instanceof FormData,
      formDataKeys: data instanceof FormData ? Array.from(data.keys()) : undefined,
      configKeys: config ? Object.keys(config) : undefined
    });

    const isAbsoluteUrl = url.startsWith('http')

    if (isAbsoluteUrl) {
      const baseUrl = this.baseUrl || ''
      const finalUrl = baseUrl && url.startsWith(baseUrl) ? url.substring(baseUrl.length) : url
      console.log('🎯 [APISERVICE] URL final:', finalUrl);
      const response = await axios.post(finalUrl, data, config)
      console.log('✅ [APISERVICE] Resposta POST recebida:', {
        status: response.status,
        statusText: response.statusText,
        hasData: !!response.data,
        dataType: typeof response.data
      });
      return response
    }

    console.log('🎯 [APISERVICE] URL final:', url);
    const response = await axios.post(url, data, config)

    console.log('✅ [APISERVICE] Resposta POST recebida:', {
      status: response.status,
      statusText: response.statusText,
      hasData: !!response.data,
      dataType: typeof response.data
    });

    return response
  }

  static async put(url: string, data?: any, config?: any) {
    console.log('🚀 [APISERVICE] PUT chamado:', {
      url,
      hasData: !!data,
      dataType: data?.constructor?.name || typeof data,
      isFormData: data instanceof FormData,
      formDataKeys: data instanceof FormData ? Array.from(data.keys()) : undefined
    });

    const isAbsoluteUrl = url.startsWith('http')

    if (isAbsoluteUrl) {
      const baseUrl = this.baseUrl || ''
      const finalUrl = baseUrl && url.startsWith(baseUrl) ? url.substring(baseUrl.length) : url
      console.log('🎯 [APISERVICE] URL final:', finalUrl);
      const response = await axios.put(finalUrl, data, config)
      console.log('✅ [APISERVICE] Resposta PUT recebida:', {
        status: response.status,
        statusText: response.statusText,
        hasData: !!response.data
      });
      return response
    }

    console.log('🎯 [APISERVICE] URL final:', url);
    const response = await axios.put(url, data, config)

    console.log('✅ [APISERVICE] Resposta PUT recebida:', {
      status: response.status,
      statusText: response.statusText,
      hasData: !!response.data
    });

    return response
  }

  static async delete(url: string, config?: any) {
    const isAbsoluteUrl = url.startsWith('http')

    if (isAbsoluteUrl) {
      const baseUrl = this.baseUrl || ''
      const finalUrl = baseUrl && url.startsWith(baseUrl) ? url.substring(baseUrl.length) : url
      const response = await axios.delete(finalUrl, config)
      return response
    }

    const response = await axios.delete(url, config)
    return response
  }

  static async patch(url: string, data?: any, config?: any) {
    console.log('🚀 [APISERVICE] PATCH chamado:', {
      url,
      hasData: !!data,
      dataKeys: data ? Object.keys(data) : undefined
    });

    const isAbsoluteUrl = url.startsWith('http')

    if (isAbsoluteUrl) {
      const baseUrl = this.baseUrl || ''
      const finalUrl = baseUrl && url.startsWith(baseUrl) ? url.substring(baseUrl.length) : url
      console.log('🎯 [APISERVICE] PATCH - URL final:', finalUrl);
      const response = await axios.patch(finalUrl, data, config)
      console.log('✅ [APISERVICE] Resposta PATCH recebida:', {
        status: response.status,
        statusText: response.statusText
      });
      return response
    }

    console.log('🎯 [APISERVICE] PATCH - URL final:', url);
    const response = await axios.patch(url, data, config)
    console.log('✅ [APISERVICE] Resposta PATCH recebida:', {
      status: response.status,
      statusText: response.statusText
    });
    return response
  }

  static stock = {
    findAll: (params?: any) => this.get('/backend/stock/findAll', params),
    create: (data: any) => this.post('/backend/stock', data),
    update: (id: number, data: any) => this.put(`/backend/stock/${id}`, data),
    delete: (id: number) => this.delete(`/backend/stock/${id}`),
    updateCode: (id: number, data: any) => this.patch(`/backend/stock/${id}/code`, data),
    count: (params?: any) => this.get('/backend/stock/count', params),
    getTotalStock: () => this.get('/backend/stock/getTotalStock'),
    addStockPrice: (stockId: number, data: { price: number; unitOfMeasurementId: number }) =>
      this.post(`/backend/stock/${stockId}/prices`, data),
  }

  static auth = {
    login: (credentials: any) => this.post('/backend/login', credentials),
    googleAuth: (token: any) => this.post('/backend/googleAuthenticate', token),
    magicLogin: (hash: string) => this.get('/backend/magic-login', { h: hash }),
    register: (userData: any) => this.post('/backend/user', userData),
    resetPassword: (email: string) => this.post('/backend/reset-password', { email }),
    resetPasswordConfirm: (data: any) => this.post('/backend/reset-password/reset', data)
  }

  static certificates = {
    findById: (id: number) => this.get(`/certificates/certificate/${id}`),
    findIdByServiceId: (serviceId: number) =>
      this.get(`/certificates/certificate/by-service/${serviceId}`),
    getUtils: (id: number) => this.get(`/certificates/certificate/utils/view/${id}`),
    getTypes: () => this.get('/certificates/certificate/utils/types'),
    getMaterials: (params?: any) => this.get('/certificates/certificate/utils/materials', params),
    getHeatNumbers: (params?: any) => this.get('/certificates/certificate/utils/heat-numbers', params),
    getParams: (params?: any) => this.get('/certificates/param', params)
  }

  static companies = {
    findAll: (params?: any) => this.get('/companies/companies', params),
    findById: (id: number) => this.get(`/companies/companies/${id}`),
    create: (data: any) => this.post('/companies/companies', data),
    update: (id: number, data: any) => this.put(`/companies/companies/${id}`, data),
    updateContactName: (id: number, contactName: string) => this.patch(`/companies/companies/${id}/contact-name`, { contactName }),
    createContact: (companyId: number, data: { name: string; email?: string; phone?: string }) => this.post(`/companies/companies/${companyId}/contacts`, data),
    delete: (id: number) => this.delete(`/companies/companies/${id}`),
    getTypes: () => this.get('/companies/companies/types'),
    getStates: () => this.get('/companies/companies/states'),
    getCepInfo: (cep: string) => this.post('/companies/address/cep', { cep }),
    getInscricaoEstadual: (cnpj: string) => this.get(`/companies/companies/inscricao-estadual/${cnpj}`),
    getCnpjDetails: (cnpj: string) => this.get(`/companies/companies/cnpj/${cnpj}`)
  }

  static productionFlow = {
    getFunctions: () => this.get('/production-flow/functions'),
    createFunction: (data: any) => this.post('/production-flow/functions', data),
    getMachines: (params?: any) => this.get('/production-flow/pcp/machines', params),
    createMachine: (data: any) => this.post('/production-flow/machine', data),
    updateMachine: (id: number, data: any) => this.patch(`/production-flow/machine/${id}`, data),
    updateService: (id: number, data: any) => this.patch(`/production-flow/pcp/service/${id}`, data),
    searchServices: (params?: any) => this.get('/production-flow/pcp/services/paginated', params),
    listServices: (params?: { search?: string; quantity?: number }) =>
      this.get('/production-flow/service', params),
    getServiceById: (id: number) => this.get(`/production-flow/service/${id}`),
    getService: (id: number) => this.get(`/production-flow/service/${id}`),
    createService: (data: any) => this.post('/production-flow/service', data),
    previewSubOps: (data: { serviceId: number; scriptId: number }) =>
      this.post('/production-flow/service/subop-tree-preview', data),
    generateSubOps: (serviceId: number, data: { scriptId: number; productId?: number }) =>
      this.post(`/production-flow/service/${serviceId}/generate-subops`, data),
    getServicesOfOp: (opId: number | string) => this.get(`/production-flow/pcp/services-of-op/${opId}`),
    getRawMaterials: (params?: any) => this.get('/production-flow/service/utils/raw-materials', params),
    getRawMaterialById: (id: number) => this.get(`/production-flow/service/utils/raw-materials/${id}`),
    getUtilResources: (params?: any) => this.get('/production-flow/service/utils/resources', params),
    getUtilStages: (params?: any) => this.get('/production-flow/service/utils/stages', params),
  }

  static profiles = {
    findAll: (params?: any) => this.get('/backend/profile/findAll', params),
    findById: (id: number) => this.get(`/backend/profile/find/${id}`),
    create: (data: any) => this.post('/backend/profile', data),
    patch: (id: number, data: { name?: string; permissions?: string[]; grants?: any[] }) =>
      this.patch(`/backend/profile/${id}`, data),
    delete: (id: number) => this.delete(`/backend/profile/${id}`),
    getTotal: (params?: any) => this.get('/backend/profile/count', params)
  }

  static user = {
    findById: (id: number) => this.get(`/backend/user/${id}`),
    me: () => this.get('/backend/user/me'),
    generateLink: (data: any) => this.post('/backend/user/link-generator', data),
    updateStatus: (id: number, data: { status: string }) =>
      this.patch(`/backend/user/updatestatus/${id}`, data),
  }

  static code = {
    delete: (code: string) => this.delete(`/backend/code/${code}`),
  }

  static skill = {
    updateUserSkills: (userId: number, skillIds: number[]) =>
      this.patch(`/backend/user/${userId}/skills`, { skillIds }),
  }

  static movements = {
    find: (params?: any) => this.get('/backend/stock-movement/find', params),
    getTotal: (params?: any) => this.get('/backend/stock-movement/count', params),
    findByStockId: (stockId: number) => this.get(`/backend/stock-movement/stock/${stockId}`),
    findByResourceId: (resourceId: number) => this.get(`/backend/stock-movement/resource/${resourceId}`),
  }

  static steelOrders = {
    getStocks: (params?: any) => this.get('/steel-orders/select-in-order/stocks', params),
    getMaterials: (params?: any) => this.get('/steel-orders/select-in-order/materials', params),
    getScripts: (params?: any) => this.get('/steel-orders/select-in-order/scripts', params),
    createTenant: (data: any) => this.post('/backend/tenant', data),
    findOrders: (params?: any) => this.get('/steel-orders/order', params),
    getOrder: (id: number) => this.get(`/steel-orders/order/${id}`),
    createOrder: (data: any) => this.post('/steel-orders/order', data),
    updateOrder: (id: number | string, data: any) => this.patch(`/steel-orders/order/${id}`, data),
    uploadAttachment: (data: FormData) =>
      this.post('/steel-orders/order/upload-attachment', data, { headers: { 'Content-Type': 'multipart/form-data' } }),
    getDeliveryPreview: (params: { baseDate?: string; businessDays: number }) => this.get('/steel-orders/order/delivery-preview', params),
    findOrderItemById: (id: number) => this.get(`/steel-orders/order-item/${id}`),
    getPaymentConditions: (params?: any) => this.get('/steel-orders/select-in-order/payment-conditions', params),
    createPaymentCondition: (data: { name: string }) => this.post('/steel-orders/select-in-order/payment-conditions', data),
    getPaymentMethods: () => this.get('/steel-orders/select-in-order/payment-methods'),
    getRepresentatives: (params?: any) => this.get('/steel-orders/select-in-order/representatives', params),
    createRepresentative: (data: { name: string }) => this.post('/steel-orders/select-in-order/representatives', data),
    getOrderSituations: (params?: any) => this.get('/steel-orders/select-in-order/order-situations', params),
    createOrderSituation: (data: { name: string }) => this.post('/steel-orders/select-in-order/order-situations', data),
    getGeneralClasses: (params?: any) => this.get('/steel-orders/select-in-order/general-classes', params),
    createGeneralClass: (data: { name: string }) => this.post('/steel-orders/select-in-order/general-classes', data),
    getShippingTypes: (params?: any) => this.get('/steel-orders/select-in-order/shipping-types', params),
    createShippingType: (data: { name: string }) => this.post('/steel-orders/select-in-order/shipping-types', data),
    deleteShippingType: (id: number) => this.delete(`/steel-orders/select-in-order/shipping-types/${id}`),
    getOrderTypes: (params?: any) => this.get('/steel-orders/select-in-order/order-types', params),
    createOrderType: (data: { name: string }) => this.post('/steel-orders/select-in-order/order-types', data),
    deleteOrderType: (id: number) => this.delete(`/steel-orders/select-in-order/order-types/${id}`),
    deleteRepresentative: (id: number) => this.delete(`/steel-orders/select-in-order/representatives/${id}`),
    deleteOrderSituation: (id: number) => this.delete(`/steel-orders/select-in-order/order-situations/${id}`),
    deleteGeneralClass: (id: number) => this.delete(`/steel-orders/select-in-order/general-classes/${id}`),
    getServices: (params?: any) => this.get('/steel-orders/select-in-order/services', params),
    getScriptBreakdown: (scriptId: number, params: { quantity: number; unitOfMeasurementId?: number }) =>
      this.get(`/steel-orders/select-in-order/scripts/${scriptId}/breakdown`, params),
  }

  static ocr = {
    process: (data: any) => this.post('https://ordeno-ocr-260311756054.southamerica-east1.run.app/ocr', data)
  }

  static addStockModal = {
    uploadExcel: (data: any, headers: any) => this.post('/backend/import-from-excel/upload', data, { headers }),
    createStock: (endpoint: string, data: any) => this.post(endpoint, data),
    getStockData: (endpoint: string) => this.get(endpoint)
  }

  static reverseMovement = {
    reverse: (ploomesId: number, data: any) => this.patch(`/backend/reverse-stock-movement/${ploomesId}`, data)
  }

  static admin = {
    inviteNewAdmin: (email: string) => this.post('/backend/new-admin/email', { email })
  }

  static resources = {
    getUnits: () => this.get('/resources/resource/util/units'),
    findById: (id: number) => this.get(`/resources/resource/${id}`),
    create: (data: any) => this.post('/resources/resource', data),
    update: (id: number, data: any) => this.patch(`/resources/resource/${id}`, data),
    delete: (id: number) => this.delete(`/resources/resource/${id}`),
    getCategories: (params?: any) => this.get('/resources/resource/util/categories', params),
    createCategory: (data: any) => this.post('/resources/resource/util/categories', data),
    deleteCategory: (id: number) => this.delete(`/resources/resource/util/categories/${id}`),
    getTypes: (params?: any) => this.get('/resources/resource/util/types', params),
    createType: (data: any) => this.post('/resources/resource/util/types', data),
    deleteType: (id: number) => this.delete(`/resources/resource/util/types/${id}`),
    getColors: (params?: any) => this.get('/resources/resource/util/colors', params),
    createColor: (data: any) => this.post('/resources/resource/util/colors', data),
    deleteColor: (id: number) => this.delete(`/resources/resource/util/colors/${id}`)
  }

  static services = {
    getMachines: (params?: any) => this.get('/services/service-stage/util/machine', params),
    getServices: (params?: any) => this.get('/production-flow/pcp/services', params),
    updateService: (id: number, data: any) => this.patch(`/production-flow/service/${id}`, data),
    findById: (id: number) => this.get(`/services/service-stage/${id}`),
    create: (data: any) => this.post('/services/service-stage', data),
    update: (id: number, data: any) => this.patch(`/services/service-stage/${id}`, data),
    getCategories: (params?: any) => this.get('/services/service-stage/util/categories', params),
    createCategory: (data: any) => this.post('/services/service-stage/util/categories', data),
    deleteCategory: (id: number, cascade?: boolean) => this.delete(`/services/service-stage/util/categories/${id}${cascade ? '?cascade=true' : ''}`),
    getTypes: (params?: any) => this.get('/services/service-stage/util/types', params),
    createType: (data: any) => this.post('/services/service-stage/util/types', data),
    deleteType: (id: number) => this.delete(`/services/service-stage/util/types/${id}`),
    getAreas: (params?: any) => this.get('/services/service-stage/util/areas', params),
    createArea: (data: any) => this.post('/services/service-stage/util/areas', data),
    deleteArea: (id: number, cascade?: boolean) => this.delete(`/services/service-stage/util/areas/${id}${cascade ? '?cascade=true' : ''}`),
    getSectors: (params?: any) => this.get('/services/service-stage/util/sectors', params),
    createSector: (data: any) => this.post('/services/service-stage/util/sectors', data),
    deleteSector: (id: number) => this.delete(`/services/service-stage/util/sectors/${id}`),
    createMachine: (data: any) => this.post('/services/service-stage/util/machine', data),
    deleteMachine: (id: number) => this.delete(`/services/service-stage/util/machine/${id}`),
    getUnits: () => this.get('/services/service-stage/util/units'),
    addStageCost: (stageId: number, data: { cost: number; unitOfMeasurementId: number; markup?: number }) =>
      this.post(`/services/service-stage/${stageId}/costs`, data),
  }

  static pcp = {
    findById: (id: number) => this.get(`/production-flow/pcp/${id}`),
    addService: (data: any) => this.post('/production-flow/pcp/service', data),
    confirm: (id: number, data: any) => this.patch(`/production-flow/pcp/${id}/status`, data),
    generatePDF: (id: number, params?: any) => this.get(`/production-flow/pcp/${id}/export`, params),
    getHistory: (id: number) => this.get(`/production-flow/pcp/${id}/history`),
    selectMaterials: (data: any) => this.post('/production-flow/pcp/select-materials', data),
    selectServices: (data: any) => this.post('/production-flow/pcp/select-services', data),
    split: (id: number, data: any) => this.post(`/production-flow/pcp/${id}/split`, data),
    discountItems: (opId: number, data: any) => this.post(`/production-flow/pcp/discount/${opId}`, data),
    calculateByFormat: (data: {
      formatType: string;
      dim1?: number;
      dim2?: number;
      density: number;
      quantity: number;
      unit: 'KG' | 'MM';
    }) => this.post('/production-flow/pcp/calculate-by-format', data),
  }

  static structure = {
    getColumns: (id: number) => this.get(`/certificates/column/${id}`)
  }

  static status = {
    getCurrentStatus: (params?: any) => this.get('/backend/stockStatus/list', params),
    deleteStatus: (status: string | number) => this.delete(`/backend/stockStatus/${status}`),
    createStatus: (data: { name: string }) => this.post('/backend/stockStatus', data),
  }

  static parameters = {
    getFormats: (params?: any) => this.get('/certificates/param/formats', params)
  }

  static stockLookup = {
    getMaterials: (params?: any) => this.get('/backend/material/list', params),
    getMaterialsForResource: (params?: any) => this.get('/backend/material/list/resource', params),
    getMaterialsForStock: (params?: any) => this.get('/backend/material/list/stock', params),
    createMaterial: (data: { name: string; type?: 'STOCK' | 'RESOURCE' }) => this.post('/backend/material', data),
    deleteMaterial: (id: number) => this.delete(`/backend/material/${id}`),
    getFormats: (params?: any) => this.get('/backend/format/list', params),
    createFormat: (data: any) => this.post('/backend/format', data),
    deleteFormat: (id: number) => this.delete(`/backend/format/${id}`),
    getFabrications: (params?: any) => this.get('/backend/fabrication/list', params),
    createFabrication: (data: any) => this.post('/backend/fabrication', data),
    deleteFabrication: (id: number) => this.delete(`/backend/fabrication/${id}`),
    searchNcmCatalogo: (q?: string, limit?: number, offset?: number) => this.get('/backend/ncm/catalogo', { q, limit, offset }),
    getShelfs: (params?: any) => this.get('/backend/shelf/list', params),
    createShelf: (data: any) => this.post('/backend/shelf', data),
    deleteShelf: (id: number) => this.delete(`/backend/shelf/${id}`),
    getStockLocations: (params?: any) => this.get('/backend/stockLocation/list', params),
    createStockLocation: (data: any) => this.post('/backend/stockLocation', data),
    deleteStockLocation: (id: number) => this.delete(`/backend/stockLocation/${id}`),
    getStockStreets: (params?: any) => this.get('/backend/stockStreet/list', params),
    createStockStreet: (data: any) => this.post('/backend/stockStreet', data),
    deleteStockStreet: (id: number) => this.delete(`/backend/stockStreet/${id}`),
    getStockStatuses: (params?: any) => this.get('/backend/stockStatus/list', params),
    createStockStatus: (data: any) => this.post('/backend/stockStatus', data),
    deleteStockStatus: (id: number) => this.delete(`/backend/stockStatus/${id}`),
    getColors: (params?: any) => this.get('/backend/color/list', params),
    createColor: (data: any) => this.post('/backend/color', data),
    deleteColor: (id: number) => this.delete(`/backend/color/${id}`),
    getFamilies: (params?: any) => this.get('/backend/family/list', params),
    createFamily: (data: any) => this.post('/backend/family', data),
    deleteFamily: (id: number) => this.delete(`/backend/family/${id}`),
    getOriginCountries: (params?: any) => this.get('/backend/originCountry/list', params),
    createOriginCountry: (data: any) => this.post('/backend/originCountry', data),
    deleteOriginCountry: (id: number) => this.delete(`/backend/originCountry/${id}`),
    getFinishings: (params?: any) => this.get('/backend/finishing/list', params),
    createFinishing: (data: any) => this.post('/backend/finishing', data),
    deleteFinishing: (id: number) => this.delete(`/backend/finishing/${id}`),
    getHeatNumbers: (params?: any) => this.get('/backend/heat-number/list', params),
    createHeatNumber: (data: any) => this.post('/backend/heat-number', data),
    deleteHeatNumber: (id: number) => this.delete(`/backend/heat-number/${id}`),
    getHeatTreatments: (params?: any) => this.get('/backend/heatTreatment/list', params),
    createHeatTreatment: (data: any) => this.post('/backend/heatTreatment', data),
    deleteHeatTreatment: (id: number) => this.delete(`/backend/heatTreatment/${id}`),
  }

  static infiniteSelect = {
    get: (url: string, config: any) => this.get(url, config?.params, config),
    post: (url: string, payload: any, config: any) => this.post(url, payload, config),
    delete: (url: string, config: any) => this.delete(url, config)
  }

  static occurrences = {
    findAll: (params?: any) => this.get('/production-flow/occurrence', params),
    findById: (id: number) => this.get(`/production-flow/occurrence/${id}`),
    create: (data: any) => this.post('/production-flow/occurrence', data),
    update: (id: number, data: any) => this.patch(`/production-flow/occurrence/${id}`, data),
    delete: (id: number) => this.delete(`/production-flow/occurrence/${id}`),
    uploadFiles: (id: number, fileIds: number[]) =>
      this.post(`/production-flow/occurrence/${id}/upload-files`, { fileIds }),
    downloadFile: (occurrenceId: number, fileId: number) =>
      this.get(`/production-flow/occurrence/${occurrenceId}/files/${fileId}/download`)
  }

  static stages = {
    findAll: (params?: any) => this.get('/production-flow/stages', params)
  }

  static productFinal = {
    findAll: (params?: any) => this.get('/product-final/product', params),
    findById: (id: number) => this.get(`/product-final/product/${id}`),
    getScript: (id: number) => this.get(`/product-final/script/${id}`),
  }

  static buyOrder = {
    findAll: () => this.get('/production-flow/buy-order'),
    create: (data: any) => this.post('/production-flow/buy-order', data),
    getByProduction: (productionId: number) =>
      this.get(`/production-flow/buy-order/by-production/${productionId}`),
    getById: (id: number) => this.get(`/production-flow/buy-order/${id}`),
    update: (id: number, data: any) =>
      this.patch(`/production-flow/buy-order/${id}`, data),
    delete: (id: number) => this.delete(`/production-flow/buy-order/${id}`),
    consumeFromStock: (id: number) =>
      this.post(`/production-flow/buy-order/${id}/consume-from-stock`),
    markPurchased: (id: number) =>
      this.post(`/production-flow/buy-order/${id}/mark-purchased`),
    bulkMarkPurchased: (ids: number[]) =>
      this.post('/production-flow/buy-order/bulk/mark-purchased', { ids }),
    bulkConsumeFromStock: (ids: number[]) =>
      this.post('/production-flow/buy-order/bulk/consume-from-stock', { ids }),
  }

  static purchaseMaterial = {
    findAll: () => this.get('/production-flow/purchase-material'),
    lookup: (type: 'MATERIA_PRIMA' | 'INSUMO', search?: string) =>
      this.get('/production-flow/purchase-material/lookup', {
        type,
        ...(search ? { search } : {}),
      }),
    getUnits: () => this.get('/production-flow/purchase-material/units'),
    getById: (id: number) => this.get(`/production-flow/purchase-material/${id}`),
    create: (data: any) => this.post('/production-flow/purchase-material', data),
    update: (id: number, data: any) =>
      this.patch(`/production-flow/purchase-material/${id}`, data),
    delete: (id: number) => this.delete(`/production-flow/purchase-material/${id}`),
  }

  static purchaseDemand = {
    findAll: (status?: string) =>
      this.get('/production-flow/purchase-demand', status ? { status } : undefined),
    getById: (id: number) => this.get(`/production-flow/purchase-demand/${id}`),
    create: (data: any) => this.post('/production-flow/purchase-demand', data),
    update: (id: number, data: any) =>
      this.patch(`/production-flow/purchase-demand/${id}`, data),
    delete: (id: number) => this.delete(`/production-flow/purchase-demand/${id}`),
  }

  static purchaseOrder = {
    findAll: (params?: { status?: string; type?: string }) =>
      this.get('/production-flow/purchase-order', params),
    getById: (id: number) => this.get(`/production-flow/purchase-order/${id}`),
    create: (data: any) => this.post('/production-flow/purchase-order', data),
    createFromDemands: (data: any) =>
      this.post('/production-flow/purchase-order/from-demands', data),
    update: (id: number, data: any) =>
      this.patch(`/production-flow/purchase-order/${id}`, data),
    updateStatus: (id: number, status: string) =>
      this.patch(`/production-flow/purchase-order/${id}/status`, { status }),
    delete: (id: number) => this.delete(`/production-flow/purchase-order/${id}`),
  }

  static fashion = {
    findAllCollections: (params?: any) => this.get('/backend-fashion-orders/fashion-product/collections', params),
    findCollectionById: (id: number) => this.get(`/backend-fashion-orders/fashion-product/collections/${id}`),
    createCollection: (data: any) => this.post('/backend-fashion-orders/fashion-product/collections', data),
    updateCollection: (id: number, data: any) => this.put(`/backend-fashion-orders/fashion-product/collections/${id}`, data),
    deleteCollection: (id: number) => this.delete(`/backend-fashion-orders/fashion-product/collections/${id}`),
    findAllSectors: () => this.get('/backend-fashion-orders/fashion-product/sectors'),
    createSector: (data: { name: string }) => this.post('/backend-fashion-orders/fashion-product/sectors', data),
    deleteSector: (id: number) => this.delete(`/backend-fashion-orders/fashion-product/sectors/${id}`),
    findAllPantones: (params?: any) => this.get('/backend-fashion-orders/fashion-product/pantones', params),
    findAllGrades: () => this.get('/backend-fashion-orders/fashion-product/grades'),
    findAllGroups: () => this.get('/backend-fashion-orders/fashion-product/groups'),
    createGroup: (data: { name: string }) => this.post('/backend-fashion-orders/fashion-product/groups', data),
    deleteGroup: (id: number) => this.delete(`/backend-fashion-orders/fashion-product/groups/${id}`),
    findAllResourceCategories: () => this.get('/backend-fashion-orders/fashion-product/resource-categories'),
    findAllResources: () => this.get('/backend-fashion-orders/fashion-product/resources'),
    getCollectionFamilies: (id: number) => this.get(`/backend-fashion-orders/fashion-product/collections/${id}/families`),
    createCollectionColor: (collectionId: number, data: any) => this.post(`/backend-fashion-orders/fashion-product/collections/${collectionId}/colors`, data),
    deleteCollectionColor: (collectionId: number, colorId: number) => this.delete(`/backend-fashion-orders/fashion-product/collections/${collectionId}/colors/${colorId}`),
    createColor: (data: any) => this.post('/backend-fashion-orders/fashion-product/colors', data),
    createGrade: (data: { name: string; typeName: string }) => this.post('/backend-fashion-orders/fashion-product/grades', data),
    updateGrade: (id: number, data: { name?: string; typeName?: string }) => this.put(`/backend-fashion-orders/fashion-product/grades/${id}`, data),
    deleteGrade: (id: number) => this.delete(`/backend-fashion-orders/fashion-product/grades/${id}`),
    findAllEpisodes: (params?: any) => this.get('/backend-fashion-orders/fashion-product/episodes', params),
    createEpisode: (collectionId: number, data: { name: string }) => this.post(`/backend-fashion-orders/fashion-product/collections/${collectionId}/episodes`, data),
    deleteEpisode: (id: number) => this.delete(`/backend-fashion-orders/fashion-product/episodes/${id}`),
    createFamily: (data: { name: string; collectionId: number }) => this.post('/backend-fashion-orders/fashion-product/families', data),
    findAllFamilies: (params?: any) => this.get('/backend-fashion-orders/fashion-product/families', params),
    deleteFamily: (id: number) => this.delete(`/backend-fashion-orders/fashion-product/families/${id}`)
  }

  static fiscal = {
    getInvoices: (params?: { take?: number; skip?: number; search?: string; filters?: string }) => this.get('/fiscal/invoice', params),
    getInvoice: (id: number) => this.get(`/fiscal/invoice/${id}`),
    getEligibleNfeItems: (orderId: number) => this.get('/fiscal/invoice/nfe/items', { orderId, t: Date.now() }),
    createNfe: (data: any) => this.post('/fiscal/invoice/nfe', data),
    updateInvoice: (id: number, data: any) => this.patch(`/fiscal/invoice/${id}`, data),
    removeInvoiceItem: (invoiceId: number, itemId: number, quantidade: number) =>
      this.patch(`/fiscal/invoice/${invoiceId}/items/${itemId}`, { quantidadeARemover: quantidade }),
    addInvoiceItems: (id: number, items: any[]) => this.patch(`/fiscal/invoice/${id}/items`, { items }),
    deleteInvoice: (id: number) => this.delete(`/fiscal/invoice/${id}`),
    emitir: (id: number) => this.post(`/fiscal/invoice/${id}/emitir`),
    cancelar: (id: number) => this.post(`/fiscal/invoice/${id}/cancelar`),
    nfeStatus: (id: number) => this.get(`/fiscal/invoice/${id}/nfe-status`),
    lookup: (params: { ncmId?: number; nbsId?: number; cfopId: number; stateId: number; companyEmissorId?: number }) =>
      this.get('/fiscal/tax-config/lookup', params),
    getNaturezas: (params: { ncmIds: string; stateId: number; companyEmissorId?: number }) =>
      this.get('/fiscal/tax-config/naturezas', params),
    cotarTributos: (data: {
      taxConfigId: number;
      stateId: number;
      companyEmissorId?: number;
      itens: { orderItemId: number; ncmId: number; valorTotal?: string }[];
    }): Promise<{ data: { itens: CotacaoTributoItem[] } }> => this.post('/fiscal/tax-config/cotacao', data),
    getCfops: (params?: { ncmId?: number; stateId?: number; companyEmissorId?: number }) => this.get('/fiscal/tax-config/cfops', params),
    getNcms: (params?: { cfopId?: number; stateId?: number; companyEmissorId?: number }) => this.get('/fiscal/tax-config/ncms', params),
    getTaxCodes: () => this.get('/fiscal/tax-config/tax-codes'),
    getClassTrib: (params?: { cstIbsCbsId?: number }) => this.get('/fiscal/tax-config/class-trib', params),
    getTaxConfigs: (params?: { filters?: string }) => this.get('/fiscal/tax-config', params),
    getTaxConfig: (id: number) => this.get(`/fiscal/tax-config/${id}`),
    createTaxConfig: (data: any) => this.post('/fiscal/tax-config/product', data),
    updateTaxConfig: (id: number, data: any) => this.patch(`/fiscal/tax-config/${id}`, data),
    deleteTaxConfig: (id: number) => this.delete(`/fiscal/tax-config/${id}`),
    getCompanyGateways: (uso?: UsoEmissor) => this.get('/fiscal/company-gateway', uso ? { uso } : undefined),
    getEmissoresPainel: (): Promise<AxiosResponse<PainelResponse>> => this.get('/fiscal/company-gateway/painel'),
    getEmissoresCandidatos: (): Promise<AxiosResponse<CandidataEmissor[]>> =>
      this.get('/fiscal/company-gateway/candidatas'),
    createEmissor: (data: CreateEmissorPayload): Promise<AxiosResponse<EmissorPainel & { vinculado: boolean }>> =>
      this.post('/fiscal/company-gateway', data),
    updateEmissor: (id: number, data: UpdateEmissorPayload): Promise<AxiosResponse<EmissorPainel>> =>
      this.patch(`/fiscal/company-gateway/${id}`, data),
    configurarNumeracaoEmissor: (id: number, data: NumeracaoPayload): Promise<AxiosResponse<EmissorPainel>> =>
      this.post(`/fiscal/company-gateway/${id}/numeracao`, data),
    uploadCertificadoEmissor: (id: number, certificado: File, senha: string): Promise<AxiosResponse<EmissorPainel>> => {
      const form = new FormData()
      form.append('certificado', certificado)
      form.append('senha', senha)
      return this.post(`/fiscal/company-gateway/${id}/certificado`, form)
    },
    listNcmProfiles: (params?: ListNcmProfilesParams): Promise<AxiosResponse<NcmProfilesListResponse>> =>
      this.get('/fiscal/tax-config/ncm-profiles', params),
    listNcmNaturezas: (params: ListNcmNaturezasParams): Promise<AxiosResponse<NcmNaturezaDto[]>> =>
      this.get('/fiscal/tax-config/ncm-naturezas', params),
    upsertNcmProfile: (data: UpsertNcmProfilePayload): Promise<AxiosResponse<NcmProfileDto>> =>
      this.post('/fiscal/tax-config/ncm-profiles', data),
    updateNcmProfile: (id: number, data: UpdateNcmProfilePayload): Promise<AxiosResponse<NcmProfileDto>> =>
      this.patch(`/fiscal/tax-config/ncm-profiles/${id}`, data),
    deleteNcmProfile: (id: number): Promise<AxiosResponse<{ id: number }>> =>
      this.delete(`/fiscal/tax-config/ncm-profiles/${id}`),
    getNcmVinculos: (ncmId: number): Promise<AxiosResponse<NcmVinculosResponse>> =>
      this.get(`/fiscal/tax-config/ncm-profiles/${ncmId}/vinculos`),
    getNcmVinculoResumo: (tipo: NcmVinculoTipo, id: number): Promise<AxiosResponse<NcmVinculoResumo>> =>
      this.get(`/fiscal/tax-config/ncm-vinculos/${tipo}/${id}/resumo`),
    getNcmVinculoCandidatos: (params: {
      tipo: NcmVinculoTipo;
      ncmId: number;
      search?: string;
      limit?: number;
    }): Promise<AxiosResponse<{ itens: NcmVinculoCandidato[] }>> =>
      this.get('/fiscal/tax-config/ncm-vinculos/candidatos', params),
    previaNcmVinculo: (data: NcmVinculoTrocaPayload): Promise<AxiosResponse<NcmVinculoPrevia>> =>
      this.post('/fiscal/tax-config/ncm-vinculos/previa', data),
    trocarNcmVinculo: (data: NcmVinculoTrocaPayload): Promise<AxiosResponse<NcmVinculoTrocaResultado>> =>
      this.put('/fiscal/tax-config/ncm-vinculos', data),
    getNcmCatalogoSugestoes: (): Promise<AxiosResponse<{ posicoes: NcmCatalogoPosicao[] }>> =>
      this.get('/fiscal/tax-config/ncm-catalogo/sugestoes'),
    removerNcmDaLista: (ncmId: number): Promise<AxiosResponse<{ removido: boolean; regrasRemovidas: number }>> =>
      this.delete(`/fiscal/tax-config/ncm-profiles/ncm/${ncmId}`),
    getEnquadramentosIpi: (cst?: string): Promise<AxiosResponse<EnquadramentoIpiOption[]>> =>
      this.get('/fiscal/tax-config/enquadramentos-ipi', cst ? { cst } : undefined),
  }

  static systemSettings = {
    getMaintenanceStatus: () => this.get('/backend/system-settings/maintenance'),
    toggleMaintenance: (data: { enabled: boolean; message?: string }) =>
      this.patch('/backend/system-settings/maintenance', data),
  }
}

export default ApiService
